export const ExampleCodeSnippets = {
  apiCalls: `# video search on "cats"
curl --location --max-time 1 --request GET 'https://api.giphy.com/v1 /clips/search?api_key={API_KEY}&q=cats&limit=5'

# first 10 trending videos
curl --location --max-time 1 --request GET 'https://api.giphy.com/v1 /clips/trending?api_key={API_KEY}&limit=10'
`,
  videoContentOnWeb: `<video src="some-giphy-rendition.mp4" autoPlay loop/>
`,
  iosInstantiatePlayerItem: `let playerItem = AVPlayerItem(url: url)
`,
  avPlayerLooper: `let videoPlayer = AVQueuePlayer(items: [playerItem])

let playerLooper = AVPlayerLooper(player: videoPlayer, templateItem:  playerItem)
`,
} as const
